import { CompanyTitledPage } from "../../TitledPage";

import CustomerInfoEditTable from "../CustomerInfoEditTable";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import {
  searchCustomerInfoList,
  updateCustomerInfo
} from "../../../http/api/CustomerAPI";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";

const getCustomerLocationState = (customerId) => ({
  customerId: customerId,
});

// 取引先情報編集ページ
export default function CustomerInformationEditPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const customerId = location.state.customerId;
  const customer = useInputObject({});

  // 更新中をあらわすstate
  const [isUpdating, setUpdating] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged} = useContext(ScreenStatusContext);

  //取引先情報を取得
  useEffect(() => {
    GetCustomerInfo();
  }, []);
  async function GetCustomerInfo() {
    let response = await searchCustomerInfoList({ customerId });
    customer.setValue(response.listCustomerInfo[0]);
  }

  //取引先情報を編集
  const updateCustomerInfoData = async () => {
    setUpdating(true);
    customer.Value.updatedId = 1; //TODO JWTを追加した後削除する
    const updatedCustomerId = await updateCustomerInfo(customer.Value);
    alert(`${customer.Value.customerName}様の情報を編集しました`);
  };

  //取引先画面に移動する
  const moveCustomerInfo = () => {
    navigate(SYSTEM_PATH_COMPANY + "/customer_information", {
      state: getCustomerLocationState(customerId),
    });
  };

  const onClickReturnCustomerInfo = (event) => {
    if (confirmWhenChanged(isChanged)) {
      moveCustomerInfo();
    }
  };

  // 取引先編集ボタンをクリック
  const onClickUpdate = async (event) => {
    await updateCustomerInfoData();
    moveCustomerInfo();
  };

  return (
    <CompanyTitledPage title="取引先情報編集">
      <Typography>取引先ID : {customerId}</Typography>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography fontWeight="bold" fontSize={30}>
            {customer.Value.customerName}
          </Typography>
        </Grid>
      </Grid>

      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              取引先基本情報の編集
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickUpdate} disabled={isUpdating}>
              更新
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickReturnCustomerInfo}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <CustomerInfoEditTable customer={customer} />
    </CompanyTitledPage>
  );
}
